module.exports = __webpack_public_path__ + "static/media/spark.1452f112.svg";